import { axiosInstance } from "../api";

/**
 * 앱 결제 화면의 Google Ads 전환 — 백엔드 /ad/google-ads/app-event/send 로 보내면 서버가 웹퍼널(Google Ads) 유입 유저만 골라
 * Data Manager API 로 올리고("결제 페이지 뷰 (API)"·"결제 버튼 클릭 (API)"), 나머지는 건너뛴다.
 * 브리지가 필요 없어 인앱·브라우저 공통이고, 실패해도 결제 화면에 영향이 없도록 삼킨다.
 */
const APP_EVENT_ENDPOINT = "/ad/google-ads/app-event/send";

export type GoogleAdsAppEvent = "payment_page_view" | "begin_checkout";

export function sendGoogleAdsAppEvent(event: GoogleAdsAppEvent) {
  axiosInstance.post(APP_EVENT_ENDPOINT, { event }).catch(() => void 0);
}
